import React from 'react';

export const MeetsIcon = () => {
  return (
    <svg
      width="65"
      height="20"
      viewBox="0 0 65 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      className="ng-scope"
    >
      <path
        d="M22.7266 16.4406V2H24.5675L29.555 10.7933H29.6355L34.6208 2H36.4617V16.4406H34.6208V7.86874L34.7013 5.44846H34.6208L30.136 13.3758H29.0545L24.5697 5.44846H24.4892L24.5697 7.86874V16.4406H22.7266ZM43.1901 16.7628C41.7082 16.7628 40.5048 16.2652 39.5757 15.2699C38.6487 14.2746 38.1852 13.0184 38.1852 11.4992C38.1852 10.061 38.6356 8.82458 39.5365 7.78763C40.4374 6.75287 41.5885 6.23549 42.9899 6.23549C44.4435 6.23549 45.6098 6.71341 46.4824 7.66705C47.3572 8.62289 47.7946 9.8988 47.7946 11.4992L47.775 11.8412H40.0283C40.0805 12.8365 40.4113 13.6235 41.0184 14.2001C41.6255 14.7788 42.3371 15.0682 43.1509 15.0682C44.4718 15.0682 45.3661 14.5026 45.834 13.3736L47.4747 14.0598C47.1548 14.8271 46.626 15.4694 45.8927 15.9868C45.1572 16.5042 44.2563 16.7628 43.1901 16.7628ZM45.8318 10.3088C45.7926 9.74315 45.5337 9.20604 45.0615 8.69524C44.5871 8.18443 43.8842 7.92794 42.9485 7.92794C42.2674 7.92794 41.6777 8.14278 41.1772 8.57247C40.6767 9.00216 40.3329 9.58092 40.1458 10.3066H45.8318V10.3088ZM53.6155 16.7628C52.1336 16.7628 50.9302 16.2652 50.0011 15.2699C49.0741 14.2746 48.6106 13.0184 48.6106 11.4992C48.6106 10.061 49.061 8.82458 49.9619 7.78763C50.8628 6.75287 52.0139 6.23549 53.4153 6.23549C54.8689 6.23549 56.0352 6.71341 56.9078 7.66705C57.7826 8.62289 58.22 9.8988 58.22 11.4992L58.2004 11.8412H50.4537C50.5059 12.8365 50.8367 13.6235 51.4438 14.2001C52.0509 14.7788 52.7625 15.0682 53.5763 15.0682C54.8972 15.0682 55.7915 14.5026 56.2594 13.3736L57.9001 14.0598C57.5802 14.8271 57.0514 15.4694 56.3181 15.9868C55.5848 16.5042 54.6839 16.7628 53.6155 16.7628ZM56.2572 10.3088C56.218 9.74315 55.9591 9.20604 55.4869 8.69524C55.0125 8.18443 54.3096 7.92794 53.3739 7.92794C52.6928 7.92794 52.1031 8.14278 51.6026 8.57247C51.1022 9.00216 50.7583 9.58092 50.5712 10.3066H56.2572V10.3088ZM63.5121 16.6006C62.485 16.6006 61.6995 16.3244 61.1598 15.7741C60.6202 15.2239 60.3482 14.4434 60.3482 13.435V8.25239H58.6269V6.55776H60.3482V3.53241H62.1891V6.55776H64.5914V8.25239H62.1891V13.2946C62.1891 14.3711 62.6286 14.9082 63.5099 14.9082C63.8429 14.9082 64.1236 14.8556 64.3499 14.7459L64.9897 16.3397C64.5914 16.5129 64.0975 16.6006 63.5121 16.6006Z"
        fill="#5F6368"
      ></path>
      <path
        d="M16.1127 8.05451C16.1127 3.60831 12.5317 0.00195312 8.11985 0.00195312C3.70804 0.00195312 0.126953 3.60831 0.126953 8.05451C0.126953 12.2668 3.94024 15.6828 8.11985 15.6828V18.6498C12.9744 16.1681 16.1127 12.1752 16.1127 8.05451Z"
        fill="#00897B"
      ></path>
      <path
        d="M13.063 5.14099L12.0145 8.05427H6.22826L3.90625 10.9225L12.4169 19.4967H18.1109V10.2265L13.063 5.14099Z"
        fill="url(#paint0_linear)"
      ></path>
      <g opacity="0.2">
        <path
          opacity="0.2"
          d="M8.11985 15.5761C3.9561 15.5761 0.158682 12.1877 0.128395 7.99719C0.128395 8.01608 0.126953 8.03497 0.126953 8.05386C0.126953 12.2661 3.94024 15.6821 8.11985 15.6821V15.5761ZM8.11985 18.5431V18.6492C12.9744 16.1674 16.1127 12.1746 16.1127 8.05386C16.1127 8.03642 16.1113 8.01899 16.1113 8.003C16.0839 12.1034 12.9528 16.073 8.11985 18.5431Z"
          fill="#263238"
        ></path>
      </g>
      <g opacity="0.2">
        <path
          opacity="0.2"
          d="M9.9089 11.2316H4.65049C4.38079 11.2316 4.11254 11.1284 3.9063 10.9206C3.70006 10.7128 3.59766 10.4426 3.59766 10.1709V10.2769C3.59766 10.5486 3.70006 10.8189 3.9063 11.0267C4.11254 11.2345 4.38079 11.3376 4.65049 11.3376H9.9089C10.1786 11.3376 10.4469 11.2345 10.6531 11.0267C10.8579 10.8204 10.9617 10.5486 10.9617 10.2769V10.1709C10.9617 10.4426 10.8593 10.7128 10.6531 10.9206C10.4469 11.1284 10.1772 11.2316 9.9089 11.2316ZM10.9603 8.9547L13.0631 11.0732V10.9671L10.9603 8.84863V8.9547Z"
          fill="#263238"
        ></path>
      </g>
      <rect
        x="2.35156"
        y="3.65857"
        width="13.1244"
        height="10.0257"
        fill="url(#pattern0)"
      ></rect>
      <path
        d="M10.9603 7.25938V5.93569C10.9603 5.66398 10.8579 5.39372 10.6517 5.18594C10.4469 4.97962 10.1772 4.875 9.90746 4.875H4.65049C4.38079 4.875 4.11254 4.97816 3.9063 5.18594C3.7015 5.39227 3.59766 5.66398 3.59766 5.93569V10.1741C3.59766 10.4458 3.70006 10.7161 3.9063 10.9239C4.11254 11.1316 4.38079 11.2348 4.65049 11.2348H9.9089C10.1786 11.2348 10.4469 11.1316 10.6531 10.9239C10.8579 10.7175 10.9617 10.4458 10.9617 10.1741V8.85043L13.0645 10.9689V5.1409L10.9603 7.25938Z"
        fill="#F5F5F5"
      ></path>
      <path
        d="M3.59766 5.93569V8.05418H13.0616V5.1409L10.9589 7.25938V5.93569C10.9589 5.66398 10.8565 5.39372 10.6502 5.18594C10.4454 4.97962 10.1757 4.875 9.90602 4.875H4.64905C4.37935 4.875 4.11109 4.97816 3.90485 5.18594C3.70005 5.39227 3.59766 5.66398 3.59766 5.93569Z"
        fill="#E0E0E0"
      ></path>
      <path
        d="M3.59766 7.948H13.0616V8.05407H3.59766V7.948Z"
        fill="#212121"
        fillOpacity="0.02"
      ></path>
      <path
        d="M3.59766 8.05408H13.0616V8.16015H3.59766V8.05408Z"
        fill="white"
        fillOpacity="0.05"
      ></path>
      <path
        opacity="0.2"
        d="M4.65049 4.98107H9.9089C10.1786 4.98107 10.4469 5.08423 10.6531 5.29201C10.8579 5.49834 10.9617 5.77005 10.9617 6.04176V5.93569C10.9617 5.66398 10.8593 5.39372 10.6531 5.18594C10.4483 4.97962 10.1786 4.875 9.9089 4.875H4.65049C4.38079 4.875 4.11254 4.97816 3.9063 5.18594C3.7015 5.39227 3.59766 5.66398 3.59766 5.93569V6.04176C3.59766 5.77005 3.70006 5.49979 3.9063 5.29201C4.11254 5.08569 4.38079 4.98107 4.65049 4.98107ZM10.9603 7.25938V7.36545L13.0631 5.24697V5.1409L10.9603 7.25938Z"
        fill="white"
      ></path>
      <path
        opacity="0.2"
        d="M8.11985 0.107522C12.5144 0.107522 16.0839 3.68482 16.1113 8.10777C16.1113 8.08888 16.1127 8.07145 16.1127 8.05256C16.1127 3.60636 12.5317 0 8.11985 0C3.70804 0 0.126953 3.60781 0.126953 8.05401C0.126953 8.07145 0.128395 8.08743 0.128395 8.10341C0.158682 3.68337 3.72679 0.107522 8.11985 0.107522Z"
        fill="white"
      ></path>
      <path
        d="M16.1127 8.05451C16.1127 3.60831 12.5317 0.00195312 8.11985 0.00195312C3.70804 0.00195312 0.126953 3.60831 0.126953 8.05451C0.126953 12.2668 3.94024 15.6828 8.11985 15.6828V18.6498C12.9744 16.1681 16.1127 12.1752 16.1127 8.05451Z"
        fill="url(#paint1_radial)"
      ></path>
      <defs>
        <pattern
          id="pattern0"
          patternContentUnits="objectBoundingBox"
          width="1"
          height="1"
        >
          <use xlinkHref="#image0"></use>
        </pattern>
        <linearGradient
          id="paint0_linear"
          x1="8.0335"
          y1="7.57685"
          x2="14.9992"
          y2="14.4909"
          gradientUnits="userSpaceOnUse"
        >
          <stop
            stopColor="#263238"
            stopOpacity="0.2"
          ></stop>
          <stop
            offset="1"
            stopColor="#263238"
            stopOpacity="0.02"
          ></stop>
        </linearGradient>
        <radialGradient
          id="paint1_radial"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(2.40598 2.31565) scale(16.3203 16.4421)"
        >
          <stop
            stopColor="white"
            stopOpacity="0.1"
          ></stop>
          <stop
            offset="1"
            stopColor="white"
            stopOpacity="0"
          ></stop>
        </radialGradient>
        <image
          id="image0"
          xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFsAAABFCAYAAAAl6ppyAAAACXBIWXMAAAsSAAALEgHS3X78AAAA"
        ></image>
      </defs>
    </svg>
  );
};
